import { render, staticRenderFns } from "./ReactionCanvas.vue?vue&type=template&id=e83b8118&scoped=true&"
import script from "./ReactionCanvas.vue?vue&type=script&lang=js&"
export * from "./ReactionCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ReactionCanvas.vue?vue&type=style&index=0&id=e83b8118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83b8118",
  null
  
)

export default component.exports